export const COLOR_AZURE = '#008cff'
export const COLOR_ORANGE_RED = '#ff5216'
export const COLOR_BODY_BLACK = '#475159'
export const COLOR_SILVER = '#ced3d9'
export const COLOR_WHITE = '#fff'
export const COLOR_AQUAMARINE = '#0cc'
